/// <reference path="../setup/_references.ts" />
module onvio.clientDashboard {
    'use strict';

    /**
     * Client dashboard preference options
     */
    export class ClientDashboardPreferenceValues {
        previouslySelectedClientId: string;
    }

    /**
     * Container for the preference endpoint
     */
    export class ClientDashboardPreferences implements IPreferences {
        id: string;
        application = 'StaffApplication';
        category = 'ClientDashboard';
        value: ClientDashboardPreferenceValues;
    }

    /**
     * State parameters for the client dashboard
     */
    export interface IClientDashboardStateParams extends ng.ui.IStateParamsService {
        clientId: string;
    }

    /**
     * Controller for the client dashboard
     */
    export class ClientDashboardController {
        // Bindings sent to child components
        public client: cs.IClientWithExpansionV3Dto;

        public notificationsTitle: string;
        public isClientLinkedToOnBalance: boolean;
        private loadedCompanyId: string;
        public userContactId: string;
        private companyMappings: CompanyMappingV1Dto[];
        private preferences: ClientDashboardPreferences = new ClientDashboardPreferences();
        public backgroundName: string;
        private onbalanceDomain: string;
        private onbalanceURL: string;
        private onbalanceUDSLongToken: string;
        private onbalanceWindow: Window;
        private showBillingWidgets: boolean = undefined;

        public isLoading: boolean = true;
        public isOBButtonLoading: boolean = false;
        public isSimpleTaxPayer: boolean = false;
        public customDisplayType: string;
        public customDisplayPattern: any = '{{name}} ({{code}})';
        /** In order to get the data before attempting to populate the widgets,
         * we seperate the model in the combobox since it is a namedReference
         */
        public $selectedClient: cs.IClientV3Dto;

        static $inject = [
            '$scope',
            '$rootScope',
            '$http',
            '$window',
            '$translate',
            '$stateParams',
            'AuthenticatedSessionData',
            'bmPermission',
            'bm.core.setup.clients.ClientProvider',
            'onvio.clientDashboard.ClientDashboardClientInformationService',
            'onvio.clientDashboard.PreferenceService',
            'bmLicense',
            'ThemeSetupManager',
            'bmpModalService',
            'bluemoon.components.Notifications',
            '$location',
            'bmAccess',
        ];
        constructor(
            private $scope: ng.IScope,
            $rootScope: ng.IScope,
            private $http: ng.IHttpService,
            private $window: ng.IWindowService,
            private $translate: ng.translate.ITranslateService,
            $stateParams: IClientDashboardStateParams,
            authenticatedSessionData: any,
            bmPermission: bluemoon.components.IBmPermissionService,
            private clientProvider: bm.core.setup.clients.ClientProvider,
            clientDashboardClientInformationService: ClientDashboardClientInformationService,
            private preferenceService: PreferenceService,
            private bmLicense: any,
            private themeSetupManager: any,
            private bmpModalService: bmp.ModalHelper.BmpModalService,
            private notifications: bluemoon.components.INotificationsService,
            private $location: ng.ILocationService,
            private bmAccess: any) {

            let self = this;

            authenticatedSessionData.get().then((sessionData: any) => { // TODO - ng161 - handle reject
                this.loadedCompanyId = sessionData.bindings.ApplicationConfiguration.CompanyId;
                this.userContactId = sessionData.bindings.ApplicationConfiguration.ContactId;

                this.bmLicense.has('Onbalance.Linking').then((enabled: boolean) => {
                    if (enabled) {
                        // when we switch clients, we need to see if they are linked so
                        // we don't show widgets that rely on OnBalance data
                        clientDashboardClientInformationService.loadCompanyMappings(this.loadedCompanyId).then( // TODO - ng161 - handle reject from loadCompanyMappings as well?
                            (companyMappings: CompanyMappings) => {
                                this.companyMappings = companyMappings.data;
                                if (this.client) {
                                    this.checkClientForOnBalanceMapping();
                                }
                            }
                        );
                    }
                }).catch(() => {
                    angular.noop();
                });

                //Gets Firm theme to set the background image
                this.themeSetupManager.getFirmThemeSettings(this.loadedCompanyId).then((firmTheme: any) => {
                    this.backgroundName = firmTheme.loginBackground ? firmTheme.loginBackground : 'grass';
                }).catch(() => {
                    this.backgroundName = 'grass';
                });
            });
            $scope.$on('$viewContentLoaded', () => {
                setTimeout(() => {
                    var divElements = document.querySelectorAll('div[qe-id="nav-link-edit-visible"]');
                    divElements.forEach((element) => {
                        element?.setAttribute('role', 'button');
                        element?.parentElement?.setAttribute('role', 'presentation');
                    });
                }, 2000);
            });
            // Removed Argentina-specific ARTimeAndExpense logic - always show billing widgets
            this.showBillingWidgets = true;

            this.bmAccess.has('DisableClientDashboardDisplayValueWithCode').then((disableDisplayValueWithCode: boolean) => {
                this.customDisplayType = disableDisplayValueWithCode ? '' : this.customDisplayPattern;
            }, () => {
                this.customDisplayType = this.customDisplayPattern;
            }).catch(() => {
                this.customDisplayType = '';
            });

            // load client dashboard preferences
            this.loadClientDashboardPreferences().then(() => { // TODO - ng161 - handle reject
                // once that process is completed, then see if a client id was passed
                const clientId = $stateParams.clientId || this.preferences.value.previouslySelectedClientId
                this.bmLicense.has('Internal.Capabilities').catch((e: any) => e).then((enabled: boolean) => {
                    return enabled ? validClient(clientId) : true
                }).then((valid: boolean) => {
                    if (valid) {
                        this.loadCurrentClient(clientId);
                    } else {
                        this.loadDefaultClient();
                    }
                });

                function validClient(client: any) {
                    return self.GetClientByFrp(clientId).then((result: any) => result.items.length === 1);
                }

            }).catch(() => {
                angular.noop();
            });

            this.notificationsTitle = this.$translate.instant('Onvio.Reports.ClientDashboard.Notifications');
            $scope.$watch(() => this.client, (newValue: any) => {
                if (newValue) {
                    this.checkClientForOnBalanceMapping();
                    this.storeSelectedClient(newValue.id);
                    this.isClientSimpleTaxPayer(newValue.id);
                    $rootScope.$broadcast('update-top-nav-buttons', { clientId: newValue.id });
                }
            });

            $scope.$watch(() => $location.search(), (routeParams: any) => {
                if (routeParams.clientId && routeParams.cfw == 1) {
                    $location.search('cfw', null);
                    this.editCustomFields({id: routeParams.clientId}, 'client');
                }
            });


            /**
             * Handle the post message event
             */
            let postOnBalanceMessage = (event: any) => {
                //If not coming from onbalance domain we do nothing
                if (event.origin !== self.onbalanceDomain) {
                    return;
                }
                //Send a message to onbalance with its UDSLT
                self.onbalanceWindow.postMessage({ obUDSLongToken: self.onbalanceUDSLongToken }, self.onbalanceURL);
            };

            /**
             * Add event listener for Onbalance Messages
             */
            $window.addEventListener('message', postOnBalanceMessage, false);

            /**
             * Remove listener on destroy scope
             */
            $scope.$on('$destroy', () => {
                $window.removeEventListener('message', postOnBalanceMessage);
            });

            // bm-core-setup redirects to app root after user loses visibility of a confidential contact via client widget.
            // Due to the editor being rendered in a workspace modal on top of the Client Dashboard, we need to disable the
            // client dashboard when the modal closes, during the redirect to app root.
            this.$scope.$root.$on('$stateChangeStart', (event: ng.IAngularEvent, args: any) => {
                if (args.url === '/') {
                    this.isLoading = true;
                }
            });
        }

        /**
         * Check if the Client is a Simple Vat Payer
         */
        private isClientSimpleTaxPayer(clientId: string) {
            if (this.isClientLinkedToOnBalance) {
                this.isSimpleTaxPayer = false;
                this.$http.get<any>('/api/smbcenter/samba-company/v1/client/' + clientId + '/is-simple-tax-payer').then((response: any) => {
                    this.isSimpleTaxPayer = response.data.value;
                });
            }
        }

        /**
         * Get an UDSLongToken and open a new Onbalance tab
         */
        public goToClientCompany() {
            //Validate browser because there is a bug on IE11 that POST MESSAGE event does not work ok between windows
            var isIEBrowser = !!window.navigator.userAgent.match(/MSIE|Trident/);
            if (!isIEBrowser) {
                this.isOBButtonLoading = true;
                this.$http.get<any>(`/api/smbcenter/samba-company/v1/client/${this.client.id}/credentials`).then((response: any) => {
                    this.onbalanceDomain = response.data.sambaDomain;
                    this.onbalanceURL = response.data.sambaUrl;
                    this.onbalanceUDSLongToken = response.data.sambaUdsLongToken;
                    this.onbalanceWindow = this.$window.open(this.onbalanceURL, '_blank');
                    this.isOBButtonLoading = false;
                }).catch(() => {
                    this.isOBButtonLoading = false;
                });
            } else {
                this.notifications.setError(this.$translate.instant('Onvio.Reports.ClientDashboard.upgradeIE'));
            }
        }

        /**
         * Loop through the OnBalance mappings to see if the selected client is mapped
         */
        private checkClientForOnBalanceMapping() {
            var found: boolean = false;
            angular.forEach(this.companyMappings, (mapping) => {
                if (mapping.clientId === this.client.id &&
                    mapping.childCompanyId) {
                    found = true;
                }
            });
            this.isClientLinkedToOnBalance = found;
        }

        /**
         * Load user preferences for the client dashboard
         */
        private loadClientDashboardPreferences(): ng.IPromise<void> {
            return this.preferenceService.loadPreferences(this.preferences.application, this.preferences.category)
                .then((result: IPreferences) => {
                    this.preferences = result;
                    if (!this.preferences) {
                        this.preferences = new ClientDashboardPreferences();
                    }
                    if (!this.preferences.value) {
                        this.preferences.value = new ClientDashboardPreferenceValues();
                    }
                });
        }

        /**
         * Update the client id in the user preferences
         * @param clientId
         */
        private storeSelectedClient(clientId: string) {
            this.preferences.value.previouslySelectedClientId = clientId;
            this.preferenceService.storePreference(this.preferences);
        }

        private setClient(client: cs.IClientWithExpansionV3Dto) {
            this.client = client;
            this.$selectedClient = client;

            // Change the window title to have this client's name in it.
            this.$scope.$emit('pageTitleUpdate', { containerName: client.name, itemType: 'clientdashboard' });
            this.$location.path(`/client-dashboard`).search({ clientId: client.id });
        }

        /**
         * Load the passed client to use as the currently selected client
         * @param clientId
         */
        private loadCurrentClient(clientId: string) {
            this.isLoading = true;
            // the bmp-select-combo binds to a full client, so we load it to set the default
            this.clientProvider.get(clientId, true).then(
                (result: cs.IClientV3Dto) => {
                    this.setClient(result);
                    this.isLoading = false;
                }
            ).catch(() => {
                // if we couldn't load the requested client, select the default one
                this.loadDefaultClient();
                this.isLoading = false;
            });
        }


        private loadDefaultClient() {
            this.isLoading = true;
            this.bmLicense.has('Internal.Capabilities').then((enabled: boolean) => {
                if (enabled) {
                    this.clientProvider.getViewList({ pageIndex: 1, itemsPerPage: 1, orderBy: 'name asc', frp: 'Onvio.ClientDashboard' })
                        .then((result: cs.IPagedItemsDto<cs.IClientV3Dto>) => {
                           return this.checkResultValue(result);
                        });
                }
            }, () => {
                this.clientProvider.getList({ pageIndex: 1, itemsPerPage: 1, orderBy: 'name asc' })
                    .then((result: cs.IPagedItemsDto<cs.IClientV3Dto>) => {
                        return this.checkResultValue(result);
                    });
            }).catch(() => {
                angular.noop();
            });
        }
        private checkResultValue(result: cs.IPagedItemsDto<cs.IClientV3Dto>) {
            if (result && result.currentItemCount > 0) {
                return this.clientProvider.get(result.items[0].id).then((client: cs.IClientWithExpansionV3Dto) => {
                       this.setClient(client);
                       this.isLoading = false;
                });
            }
        }

        private refreshClient() {
            this.isLoading = true;
            this.clientProvider.get(this.client.id).then((client: cs.IClientWithExpansionV3Dto) => {
                this.setClient(client);
                this.isLoading = false;
            });
        }

        public edit(model: cs.INamedReferenceDto, type: bmp.ModalHelper.AotfEntityName) {
            let onModalClose = () => {
                this.$location.url('/client-dashboard');
                this.refreshClient();
            };

            let onModalDismiss = () => {
                angular.noop();
            };

            let params: bmp.ModalHelper.IAotfParams = {
                entityName: type
            };

            this.bmpModalService.editOnTheFly(model.id, params, onModalClose, onModalDismiss);
        }

        public editCustomFields(model: cs.INamedReferenceDto, type: bmp.ModalHelper.AotfEntityName) {
            let onModalClose = () => {
                this.$location.url('/client-dashboard');
                this.refreshClient();
            };

            let onModalDismiss = () => {
                angular.noop();
            };

            let params: bmp.ModalHelper.IAotfParams = {
                entityName: type,
                stateName: 'setupClientDetail.customFields'
            };

            this.bmpModalService.editOnTheFly(model.id, params, onModalClose, onModalDismiss);
        }

        public openContactModal(model: cs.INamedReferenceDto, type: bmp.ModalHelper.AotfEntityName) {
            let onModalClose = () => {
                this.$location.url('/client-dashboard');
                this.refreshClient();
            };

            let onModalDismiss = () => {
                this.$location.url('/client-dashboard');
                angular.noop();
            };

            let params: bmp.ModalHelper.IAotfParams = {
                entityName: type,
                stateName: 'setupClientDetail.relationships'
            };

            this.bmpModalService.editOnTheFly(model.id, params, onModalClose, onModalDismiss);
        }

        public billingWidgetContext() {
            return this.showBillingWidgets === true ? this.client : undefined;
        }

        private GetClientByFrp(clientId: string) : ng.IPromise<cs.IPagedItemsDto<cs.IClientViewV2Dto>>
        {
            var filter = new bmp.Filter().where('id').equals(clientId).toString();
            var body = {
                'expand': '',
                'filterSearchSort': {
                    'filter': filter
                },
                'frp': 'Onvio.ClientDashboard'
            };
            return this.clientProvider.getViewList(body);
        }
    }

    angular.module('onvio.clientDashboard.ClientDashboardController',
        [
            'ui.router',
            'bento.modern',
            'bento.d3',
            'tmh.dynamicLocale',
            'bluemoon.components',
            'bm.core.setup.clients.ClientProvider',
            'onvio.clientDashboard.ClientDashboardClientInformationService',
            'onvio.clientDashboard.PreferenceService',
            'bmLicense',
            'onvio.setup.appearance',
            'bmpModalHelper',
            'bluemoon.components.Notifications'
        ])
        .controller('onvio.clientDashboard.ClientDashboardController', ClientDashboardController);
}
